import './bootstrap';

// Init code
Bolt.on('load', (event) => {
    const type = window.location.pathname.split('/')[1];

    if (!['admin', 'user'].includes(type)) {
        return;
    }

    // Burger Menu JS
    $('.burger-menu').on('click', () => {
        $('.burger-menu').toggleClass('active');
        $('.main-content').toggleClass('hide-sidemenu-area');
        $('.sidemenu-area').toggleClass('toggle-sidemenu-area');
        $('.top-navbar').toggleClass('toggle-navbar-area');

        axios.post(`/${type}/hide-sidemenu`, { value: Number($('.sidemenu-area').hasClass('toggle-sidemenu-area')) });
    });

    $('.responsive-burger-menu').on('click', () => {
        $('.responsive-burger-menu').toggleClass('active');
        $('.sidemenu-area').toggleClass('active-sidemenu-area');
    });

    // Metis Menu JS
    $('#sidemenu-nav').metisMenu();

    // Dropdown menu
    document.querySelectorAll('li.nav-item.dropdown').forEach((dropdown) => {
        const menu = dropdown.querySelector('div.dropdown-menu');
        let timeoutId = 0;

        dropdown.addEventListener('mouseenter', () => {
            document.querySelectorAll('div.dropdown-menu').forEach((iteratedMenu) => {
                if (iteratedMenu === menu) return;

                iteratedMenu.classList.remove('show');
            });

            window.clearTimeout(timeoutId);
            menu.classList.add('show');
        });

        dropdown.addEventListener('mouseleave', () => (timeoutId = window.setTimeout(() => menu.classList.remove('show'), 300)));
    });
});

Bolt.on('unload', (event) => {
    $('.modal').modal('hide');
    $('.tooltip').tooltip('dispose');
    $('.popover').popover('dispose');

    document.head.querySelectorAll('style').forEach((style) => {
        if (!style.hasAttribute('bolt-pin') && style.innerHTML.includes('url(/cf-fonts/')) {
            style.removeAttribute('bolt-transient');
            style.setAttribute('bolt-pin', '');
        }
    });
});

Bolt.setTargetSelectors('#app-container');
Bolt.start();
